(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    // Expose the bar's real rendered height so the sticky header (in
    // header.liquid) can offset itself below it instead of stacking on top.
    function syncHeight() {
      document.documentElement.style.setProperty('--ann-bar-height', bar.offsetHeight + 'px');
    }
    syncHeight();
    window.addEventListener('resize', syncHeight);

    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.ann__msg'));
    var dots = Array.prototype.slice.call(bar.querySelectorAll('.ann__dot'));
    if (msgs.length < 2) return;

    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4500;
    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Only devices with real hover (mouse/trackpad) get pause-on-hover.
    // Touch browsers can fire a synthetic mouseenter on tap/scroll with no
    // matching mouseleave, which would otherwise freeze the rotation for good.
    var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function show(i) {
      index = i;
      msgs.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      dots.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
        el.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }

    function start() {
      stop();
      if (reduceMotion) return;
      timer = setInterval(function () { show((index + 1) % msgs.length); }, speed);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });

    if (hasHover) {
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
    }

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aromas-card"]) return;
  try {
    
  (function () {
    function viewer() { return document.querySelector('[data-aroma-viewer]'); }
    function openViewer(fileId, label) {
      var v = viewer();
      if (!v) return;
      v.querySelector('[data-aroma-iframe]').src = 'https://drive.google.com/file/d/' + fileId + '/preview';
      v.querySelector('[data-aroma-title]').textContent = label || '';
      v.hidden = false;
      document.documentElement.classList.add('aromas-open');
    }
    function closeViewer() {
      var v = viewer();
      if (!v) return;
      v.hidden = true;
      v.querySelector('[data-aroma-iframe]').src = '';
      document.documentElement.classList.remove('aromas-open');
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-aroma-open]');
      if (open) { openViewer(open.getAttribute('data-file'), open.getAttribute('data-label')); return; }
      if (e.target.closest('[data-aroma-close]')) { closeViewer(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeViewer(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cartpg-minus]');
    var plus = e.target.closest('[data-cartpg-plus]');
    if (!minus && !plus) return;
    var row = e.target.closest('.cartpg__row');
    if (!row) return;
    var input = row.querySelector('.cartpg__qty-input');
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = 1;
    val = plus ? val + 1 : Math.max(0, val - 1);
    input.value = val;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  // Quantity stepper: +/- buttons adjust the number input, then re-sync
  // the displayed price to unit price × quantity.
  document.querySelectorAll('.pdp__qty').forEach(function (qty) {
    var input = qty.querySelector('.pdp__qty-input');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;
    function clamp(v) { return Math.max(1, v); }
    function sync() { if (window.syncQtyPrice) window.syncQtyPrice(qty); }
    minus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) - 1);
      sync();
    });
    plus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) + 1);
      sync();
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || 1);
      sync();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu drawer: open via hamburger, close via overlay / X / Escape / link tap.
  (function () {
    function menuEl() { return document.querySelector('[data-mobile-menu]'); }
    function openMenu() {
      var m = menuEl();
      if (!m) return;
      var p = m.querySelector('.mobile-menu__panel');
      if (p) void p.offsetWidth; // commit closed position so the slide animates
      m.classList.add('is-open');
    }
    function closeMenu() {
      var m = menuEl();
      if (m) m.classList.remove('is-open');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); openMenu(); return; }
      if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
      if (e.target.closest('.mobile-menu__link')) { closeMenu(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (media) {
    var slides = Array.prototype.slice.call(media.querySelectorAll('.hero__slide'));
    if (slides.length < 2) return;

    var section = media.closest('.hero');
    var heading = section ? section.querySelector('[data-hero-heading]') : null;
    var content = section ? section.querySelector('.hero__content') : null;
    var dots = section ? Array.prototype.slice.call(section.querySelectorAll('.hero__dot')) : [];
    var speed = parseInt(media.getAttribute('data-speed'), 10) || 5000;
    var index = 0;
    var timer = null;
    var hovered = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function show(i) {
      index = i;
      slides.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      dots.forEach(function (el, n) {
        el.classList.toggle('is-active', n === i);
        el.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });

      var headingSrc = heading ? slides[i].querySelector('.hero__slide-heading') : null;
      var nextText = headingSrc ? headingSrc.textContent : null;
      if (!nextText) return;

      if (content) content.style.opacity = 0;
      setTimeout(function () {
        heading.textContent = nextText;
        if (content) content.style.opacity = 1;
      }, reduceMotion ? 0 : 300);
    }

    function start() {
      stop();
      if (hovered) return;
      timer = setInterval(function () { show((index + 1) % slides.length); }, speed);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (hasHover) {
      media.addEventListener('mouseenter', function () { hovered = true; stop(); });
      media.addEventListener('mouseleave', function () { hovered = false; start(); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });

    // A tab that loads while backgrounded (or is throttled by the browser
    // during initial load) can end up with a dead timer that never
    // recovers on its own — resync whenever the page actually becomes
    // visible so the slideshow can't get stuck until a manual refresh.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') start();
    });

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Product-page quantity stepper: +/- buttons adjust the number input,
  // then re-sync the displayed price to unit price × quantity.
  document.querySelectorAll('.pdp__qty').forEach(function (qty) {
    var input = qty.querySelector('.pdp__qty-input');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    function clamp(v) { return Math.max(1, v); }
    function sync() { if (window.syncQtyPrice) window.syncQtyPrice(qty); }
    minus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) - 1);
      sync();
    });
    plus.addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) + 1);
      sync();
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || 1);
      sync();
    });
  });

  // Buy it now: add the current form's line item to the cart, then go straight to checkout.
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      btn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status >= 400) { btn.removeAttribute('disabled'); return; }
          window.location.href = '/checkout';
        })
        .catch(function () { btn.removeAttribute('disabled'); });
    });
  });

  // Notify-me: reveal the email capture panel on click.
  document.querySelectorAll('[data-notify-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.parentElement.querySelector('[data-notify-panel]');
      if (!panel) return;
      var showing = panel.hasAttribute('hidden');
      if (showing) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', showing ? 'true' : 'false');
    });
  });

  // Sync the slideshow indicator dots with the swiped slide (mobile).
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var dots = gallery.parentElement.querySelectorAll('.pdp__dot');
    if (!dots.length) return;
    gallery.addEventListener('scroll', function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"]) return;
  try {
    
  (function () {
    var KEY = 'empirical_signup_popup_dismissed';
    var popup = document.querySelector('[data-signup-popup]');
    if (!popup) return;

    var alreadySeen = false;
    try { alreadySeen = !!localStorage.getItem(KEY); } catch (e) {}

    var startedOpen = !popup.hasAttribute('hidden');

    function remember() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }

    function close() {
      popup.hidden = true;
      remember();
    }

    function open() {
      popup.hidden = false;
    }

    popup.querySelectorAll('[data-signup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });

    if (startedOpen) {
      // Server rendered it already open (a just-completed signup) — just remember.
      remember();
    } else if (!alreadySeen) {
      var delay = parseFloat(popup.getAttribute('data-delay')) || 4;
      setTimeout(open, delay * 1000);
    }

    var copyBtn = popup.querySelector('[data-signup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = popup.querySelector('[data-signup-code]');
        if (!codeEl) return;
        var text = codeEl.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = original; }, 2000);
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
